import React, { useContext } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Navbar from "react-bootstrap/Navbar";
import { NavLink } from "react-router-dom";
import { ThemeContext } from "../../App";
import { routes } from "../data/data";
import { routes as ShopRoutes } from "../../Cpanel/data/ShopData";
import { useState } from "react";
import SidebarOffcanvas from "../Sidebar/SidebarOffcanvas";
import Logo from "../../Assets/images/logoh.png";
import { ShopContext } from "../../StateManagement/Contexts/ShopContext";

const Offcanvasbar = ({ isShop, show, handleClose, setShow }) => {
  const { shopData } = useContext(ShopContext);
  let routeData;
  if (isShop) {
    routeData = ShopRoutes.filter((route) => {
      if (shopData?.type === 1) {
        return route.online;
      } else if (shopData?.type === 2) {
        return route.offline;
      }
    });
  } else if (!isShop) {
    routeData = routes;
  }
  const { theme } = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      style={{ width: "265px" }}
      className={theme === "dark" ? "offcanvas-dark" : "offcanvas-light"}
    >
      <Offcanvas.Body>
        <Navbar className="flex-column">
          <Navbar.Collapse id="basic-navbar-nav">
            <div className=" d-flex flex-column align-items-start justify-content-start w-100 ">
              <div className="d-flex justify-content-center align-items-center m-auto flex-wrap">
                <div>
                  <img src={Logo} width={80} alt="logo" />
                </div>
              </div>
              <section className="routes">
                {routeData?.map((route, index) => {
                  if (route.subRoutes) {
                    return (
                      <SidebarOffcanvas
                        key={index}
                        setIsOpen={setIsOpen}
                        route={route}
                        isOpen={isOpen}
                        setShow={setShow}
                        onClick={() => setShow(false)}
                      />
                    );
                  }
                  const IconComponent = route.icon;
                  return (
                    <NavLink
                      to={route.path}
                      key={index}
                      className="link mx-1"
                      activeclassname="active"
                      onClick={() => setShow(false)}
                    >
                      <div className="icon link">{IconComponent}</div>
                      {isOpen && <div className="link_text">{route.name}</div>}
                    </NavLink>
                  );
                })}
              </section>
            </div>
          </Navbar.Collapse>
        </Navbar>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Offcanvasbar;
